import React from "react";

export default function SubFamiliesSvgIcon(
    props: React.SVGProps<SVGSVGElement>
) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={48}
            height={48}
            viewBox="0 0 48 48"
            {...props}
        >
            <defs>
                <clipPath id="prefix__a">
                    <path
                        data-name="icon bg"
                        d="M0 24a24 24 0 1124 24A24 24 0 010 24z"
                        fill="#333"
                    />
                </clipPath>
            </defs>
            <g data-name="Groupe 8797">
                <g data-name="credit-card (2)" fill="#fff">
                    <path
                        data-name="Trac\xE9 8558"
                        d="M38.291 25.723l-2.151-12.2a3.056 3.056 0 00-3.54-2.476l-18.446 3.254a3.056 3.056 0 00-2.476 3.534l.158.9a3.057 3.057 0 00-1.836 2.8v12.08a3.056 3.056 0 003.052 3.052h18.315a3.056 3.056 0 003.052-3.052v-4.11l1.4-.246a3.052 3.052 0 002.476-3.536zm-1.87 1.326a1.379 1.379 0 01-.9.571l-1.106.2v-6.285a3.056 3.056 0 00-3.052-3.052H13.482l-.164-.932a1.388 1.388 0 011.126-1.607l18.449-3.253a1.387 1.387 0 011.607 1.121l2.151 12.2a1.379 1.379 0 01-.23 1.037zm-5.054 7.954H13.052a1.389 1.389 0 01-1.387-1.388v-5.917h21.089v5.917a1.389 1.389 0 01-1.387 1.387zM13.052 20.145h18.315a1.389 1.389 0 011.387 1.39v.724H11.665v-.724a1.389 1.389 0 011.387-1.39zm19.7 3.777v2.113H11.665v-2.114z"
                    />
                    <path
                        data-name="Trac\xE9 8559"
                        d="M18.011 31.654h-3.777a.833.833 0 100 1.665h3.777a.833.833 0 100-1.665z"
                    />
                </g>
                <g data-name="Groupe 8257">
                    <g data-name="Mask group">
                        <path
                            data-name="icon bg"
                            d="M0 24a24 24 0 1124 24A24 24 0 010 24z"
                            fill="#333"
                        />
                        <g data-name="Mask group" clipPath="url(#prefix__a)">
                            <path
                                data-name="Rectangle 2"
                                d="M33.901-1l6.764 4.24L12.128 49.03l-6.764-4.24z"
                                fill="rgba(255,255,255,0.1)"
                            />
                        </g>
                    </g>
                    <g data-name="Groupe 8301">
                        <g data-name="Groupe 8300">
                            <path
                                data-name="Trac\xE9 8561"
                                d="M37.577 35.13a.7.7 0 00-.958-.257l-2.549 1.472a.701.701 0 10.7 1.215l2.549-1.472a.7.7 0 00.258-.958z"
                                fill="#fff"
                            />
                        </g>
                    </g>
                    <g data-name="Groupe 8303">
                        <g data-name="Groupe 8302">
                            <path
                                data-name="Trac\xE9 8562"
                                d="M41.387 26.316a.691.691 0 00-.006-.086v-.006a.7.7 0 00-.015-.076l-.006-.021a.734.734 0 00-.021-.061l-.008-.021a.709.709 0 00-.036-.074.7.7 0 00-.046-.068l-.014-.017q-.02-.025-.042-.048l-.015-.015a.689.689 0 00-.058-.051.7.7 0 00-.071-.048h-.005l-8.146-4.7v-9.418-.006a.7.7 0 00-.006-.086.684.684 0 00-.016-.078l-.006-.02a.645.645 0 00-.021-.062l-.008-.019a.644.644 0 00-.084-.145l-.013-.017q-.02-.026-.043-.049l-.023-.019a.7.7 0 00-.059-.052.7.7 0 00-.074-.053h-.005l-8.496-4.906a.7.7 0 00-.7 0L14.847 11a.7.7 0 00-.072.048.7.7 0 00-.06.052l-.015.015q-.022.023-.043.049l-.013.017a.647.647 0 00-.083.145l-.008.02q-.012.03-.021.061l-.006.02a.7.7 0 00-.015.077v.005a.694.694 0 00-.006.086v9.412l-8.146 4.7a.687.687 0 00-.072.048.678.678 0 00-.059.052l-.015.015q-.022.023-.043.049l-.013.017a.7.7 0 00-.046.069.7.7 0 00-.037.075l-.008.021a.626.626 0 00-.021.061l-.006.021a.691.691 0 00-.015.076v.006a.693.693 0 00-.006.086v9.817a.7.7 0 00.351.607l8.5 4.9h.005a.7.7 0 00.077.038.7.7 0 00.074.025l.021.005a.698.698 0 00.063.012h.022a.648.648 0 00.167 0h.022c.021 0 .042-.007.063-.012l.021-.005a.679.679 0 00.074-.025h.005a.686.686 0 00.077-.038h.005l8.145-4.7 8.145 4.7h.006a.7.7 0 00.077.038h.006a.691.691 0 00.074.025l.021.005a.698.698 0 00.063.012h.022a.649.649 0 00.167 0h.022c.021 0 .042-.007.063-.012l.021-.005a.681.681 0 00.074-.025h.006a.709.709 0 00.077-.038h.006l8.5-4.9a.7.7 0 00.351-.607v-9.798a.047.047 0 00-.024-.006zm-6.344-2.442l-7.093 4.1-2.853-1.647 7.093-4.1zm-3.555-2.862l-7.093 4.1v-8.19l7.093-4.1zm-7.795-13.5l2.853 1.647-7.093 4.1-2.853-1.653zm-8.5 14.716l2.853 1.647-7.093 4.1-2.849-1.653zm-.7 17.6l-7.094-4.1v-8.191l3.022 1.744a.7.7 0 00.338.2l3.734 2.156v8.191zm.7-9.406l-2.833-1.643 7.093-4.1 2.838 1.638zm7.794 5.311l-7.093 4.1v-8.201l7.093-4.1zm0-10.621l-7.093-4.1v-8.191l3.02 1.744a.7.7 0 00.341.2l3.733 2.155v8.191zm-2.131-11.048l7.093-4.1 2.837 1.638-7.092 4.098zm10.632 25.759l-7.093-4.1v-8.186l3.021 1.744a.7.7 0 00.338.195l3.734 2.156v8.191zm.7-9.406l-2.836-1.637 7.093-4.1 2.838 1.638zm7.8 5.311l-7.094 4.1v-8.196l7.094-4.1z"
                                fill="#fff"
                            />
                        </g>
                    </g>
                    <g data-name="Groupe 8305">
                        <g data-name="Groupe 8304">
                            <path
                                data-name="Trac\xE9 8563"
                                d="M38.725 33.864a.7.7 0 000 1.4.7.7 0 000-1.4z"
                                fill="#fff"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
